exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert {\n  text-align: center;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  margin: 0;\n  border-radius: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/global/_directives/alert/alert.component.less
// module id = ./src/app/global/_directives/alert/alert.component.less
// module chunks = 0